/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const ApplicationStepMessages = defineMessages({
  title: {
    id: 'Slack.ApplicationStepMessages.title',
    defaultMessage: 'Connect {productName} to Slack'
  },
  subtitle: {
    id: 'Slack.ApplicationStepMessages.subtitle',
    defaultMessage:
      'Go to the <link>Your Apps</link> page on the Slack website. Click the app you want to use.'
  },
  stepOne: {
    id: 'Slack.ApplicationStepMessages.stepOne',
    defaultMessage:
      'On the Slack app settings page, go to the {basicInformation} tab and find the {appCredentials} section. Copy your verification token from that section to the field below.'
  },
  basicInformation: {
    id: 'Slack.ApplicationStepMessages.basicInformation',
    defaultMessage: 'Basic Information'
  },
  appCredentials: {
    id: 'Slack.ApplicationStepMessages.appCredentials',
    defaultMessage: 'App Credentials'
  },
  verificationTokenLabel: {
    id: 'Slack.ApplicationStepMessages.verificationTokenLabel',
    defaultMessage: 'Verification token'
  },
  verificationTokenPlaceholder: {
    id: 'Slack.ApplicationStepMessages.verificationTokenPlaceholder',
    defaultMessage: 'Enter verification token'
  },
  verificationTokenRequired: {
    id: 'Slack.ApplicationStepMessages.verificationTokenRequired',
    defaultMessage: 'Verification token is required'
  },
  nonEmptyVerificationToken: {
    id: 'Slack.ApplicationStepMessages.nonEmptyVerificationToken',
    defaultMessage: 'Verification token cannot be empty'
  },
  stepTwo: {
    id: 'Slack.ApplicationStepMessages.stepTwo',
    defaultMessage:
      'Go to the {oauthAndPermissions} tab. In the {botTokenScopes} section click {addAnOauthScope}, and then select the following scopes:'
  },
  oauthAndPermissions: {
    id: 'Slack.ApplicationStepMessages.oauthAndPermissions',
    defaultMessage: 'OAuth & Permissions'
  },
  botTokenScopes: {
    id: 'Slack.ApplicationStepMessages.botTokenScopes',
    defaultMessage: 'Bot Token Scopes'
  },
  addAnOauthScope: {
    id: 'Slack.ApplicationStepMessages.addAnOauthScope',
    defaultMessage: 'Add an OAuth Scope'
  },
  scopeOne: {
    id: 'Slack.ApplicationStepMessages.scopeOne',
    defaultMessage: 'app_mentions:read'
  },
  scopeTwo: {
    id: 'Slack.ApplicationStepMessages.scopeTwo',
    defaultMessage: 'chat:write'
  },
  scopeThree: {
    id: 'Slack.ApplicationStepMessages.scopeThree',
    defaultMessage: 'im:history'
  },
  scopeFour: {
    id: 'Slack.ApplicationStepMessages.scopeFour',
    defaultMessage: 'im:read'
  },
  scopeFive: {
    id: 'Slack.ApplicationStepMessages.scopeFive',
    defaultMessage: 'im:write'
  },
  stepThree: {
    id: 'Slack.ApplicationStepMessages.stepThree',
    defaultMessage:
      'On the {oauthAndPermissions} tab. Click {installAppToWorkspace}, and then click {allow}. You should be redirected back to the OAuth & Permissions page. Copy and paste your {botUserAccessTokenLabel} to the following field.'
  },
  installAppToWorkspace: {
    id: 'Slack.ApplicationStepMessages.installAppToWorkspace',
    defaultMessage: 'Install App to Workspace'
  },
  allow: {
    id: 'Slack.ApplicationStepMessages.allow',
    defaultMessage: 'Allow'
  },
  botUserAccessTokenLabel: {
    id: 'Slack.ApplicationStepMessages.botUserAccessTokenLabel',
    defaultMessage: 'Bot user OAuth access token'
  },
  botAccessTokenPlaceholder: {
    id: 'Slack.ApplicationStepMessages.botAccessTokenPlaceholder',
    defaultMessage: 'Enter a Bot user OAuth access token'
  },
  botAccessTokenRequired: {
    id: 'Slack.ApplicationStepMessages.botAccessTokenRequired',
    defaultMessage: 'Bot user OAuth access token is required'
  },
  nonEmptyBotAccessToken: {
    id: 'Slack.ApplicationStepMessages.nonEmptyBotAccessToken',
    defaultMessage: 'Bot user OAuth access token cannot be empty'
  }
});
